import { render, staticRenderFns } from "./Tensao.vue?vue&type=template&id=d2845d46"
import script from "./Tensao.vue?vue&type=script&lang=js"
export * from "./Tensao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports